module.exports = __webpack_public_path__ + "static/media/tt.29eea267.svg";